import { useTranslation } from 'react-i18next'

function NotFound() {
  const { t } = useTranslation()

  return (
    <h1 className='center-message'>
      {t("Not found")}
    </h1>
  )
}

export default NotFound
